const imageOfTheAreas = {
    'extractionMillingArea': { 
        name: 'extractionMillingArea', 
        idImg:'img1', 
        image: 'area1.png',
        colorConn: '#683604'
     },

    'extractionDiffuserArea': { 
        name: 'extractionDiffuserArea', 
        idImg:'img2', 
        image: 'area1_difusor.png',
        colorConn: '#683604'
    },

    'factoryTreatmentArea': { 
        name: 'factoryTreatmentArea', 
        idImg:'img3', 
        image: 'area2.png',
        colorConn: '#683604'
     },

    'distilleryTreatmentArea': { 
        name: 'distilleryTreatmentArea', 
        idImg:'img4', 
        image: 'area3.png',
        colorConn: '#683604'
     },

    'filteredTreatmentArea': { 
        name: 'filteredTreatmentArea', 
        idImg:'img5', 
        image: 'area3_2.png',
        colorConn: '#683604'
     },

    'evaporationArea': { 
        name: 'evaporationArea', 
        idImg:'img6', 
        image: 'area4.png',
        colorConn: '#683604'
     },
     
    'sugarFactoryArea': { 
        name: 'sugarFactoryArea', 
        idImg:'img7', 
        image: 'area5.png',
        colorConn: '#cf9846'
     },

    'fermentationArea': { 
        name: 'fermentationArea', 
        idImg:'img8', 
        image: 'area6.png',
        colorConn: '#5d9065'
     },

    'distilleryArea': { 
        name: 'distilleryArea', 
        idImg:'img9', 
        image: 'area7.png',
        colorConn: '#5d9065'
     },

    'steamGenerationArea': { 
        name: 'steamGenerationArea', 
        idImg:'img10', 
        image: 'area8.png',
        colorConn: '#861313'
     },
     
    'cogenerationArea': { 
        name: 'cogenerationArea', 
        idImg:'img11', 
        image: 'area9.png',
        colorConn: '#2a8d77'
     },

    'vinasseTreatmentArea': { 
        name: 'vinasseTreatmentArea', 
        idImg:'img12', 
        image: 'area11.png',
        colorConn: '#fccc9e'
     },

    'yeastFactoryArea': { 
        name: 'yeastFactoryArea', 
        idImg:'img13', 
        image: 'area12.png',
        colorConn: '#fccc9e'
     },

    'refineryArea': { 
        name: 'refineryArea', 
        idImg:'img14', 
        image: 'refinaria.png',
        colorConn: '#cf9846'
    },

    'extractorsArea': { 
        name: 'extractorsArea', 
        idImg:'img15', 
        image: 'area13.png',
        colorConn: '#fccc9e'
    },

    'finishersArea': { 
        name: 'finishersArea', 
        idImg:'img16', 
        image: 'area14.png',
        colorConn: '#cf9846'
    },

    'washingAndCellsFactoryArea': { 
        name: 'washingAndCellsFactoryArea', 
        idImg:'img17', 
        image: 'area15.png',
        colorConn: '#cf9846'
    },

    'centrifugeArea': { 
        name: 'centrifugeArea', 
        idImg:'img18', 
        image: 'area16.png',
        colorConn: '#cf9846'
    },

    'juiceEvaporationArea': { 
        name: 'juiceEvaporationArea', 
        idImg:'img19', 
        image: 'area17.png',
        colorConn: '#cf9846'
    },

    'essentialOilArea': { 
        name: 'essentialOilArea', 
        idImg:'img20', 
        image: 'area_8_oleo_essencial.png',
        colorConn: '#cf9846'
    },

    'nfcArea': { 
        name: 'nfcArea', 
        idImg:'img21', 
        image: 'area_3_nfc.png',
        colorConn: '#cf9846'
    },

    'rationArea': { 
        name: 'rationArea', 
        idImg:'img22', 
        image: 'area_6_racao.png',
        colorConn: '#cf9846'
    },

    'cellsFactoryArea': { 
        name: 'cellsFactoryArea', 
        idImg:'img23', 
        image: 'area_9_fabrica_celulas_.png',
        colorConn: '#cf9846'
    },

    'washingArea': { 
        name: 'washingArea', 
        idImg:'img24', 
        image: 'area_4_pulp_wash.png',
        colorConn: '#cf9846'
    },

    'coreSectorArea': { 
        name: 'coreSectorArea', 
        idImg:'img25', 
        image: 'area_5_setor_core.png',
        colorConn: '#cf9846'
    },

    'dryBarkArea': { 
        name: 'dryBarkArea', 
        idImg:'img26', 
        image: 'area_casca_seca.png',
        colorConn: '#cf9846'
    },

    'fbpArea': { 
        name: 'fbpArea', 
        idImg:'img27', 
        image: 'area_fbp.png',
        colorConn: '#cf9846'
    },

    'fermentacaoArea': { 
        name: 'fermentacaoArea', 
        idImg:'img28', 
        image: 'area_fermentacao.png',
        colorConn: '#cf9846'
    },
    
    'ddgsArea': { 
        name: 'ddgsArea', 
        idImg:'img29', 
        image: 'area_ddgs.png',
        colorConn: '#cf9846'
    },

    'cozedorLiquefacaoArea': { 
        name: 'cozedorLiquefacaoArea', 
        idImg:'img30', 
        image: 'area_cozedor_liquefacao.png',
        colorConn: '#cf9846'
    },

    'distilleryCor': { 
        name: 'distilleryCor', 
        idImg:'img31', 
        image: 'area7.png',
        colorConn: '#5d9065'
     },

    
    // WDG_milho, DDGS_milho, 
    'distilleryCor': { 
        name: 'distilleryCor', 
        idImg:'img31', 
        image: 'area7.png',
        colorConn: '#5d9065'
     },
    'BOS_Milho': { 
        name: 'BOS_Milho', 
        idImg:'img32', 
        image: 'area_bos_milho.png',
        colorConn: '#cf9846'
    },
    'WDG_milho': { 
        name: 'WDG_milho', 
        idImg:'img33', 
        image: 'area_wdg_milho.png',
        colorConn: '#cf9846'
    },

}

export default imageOfTheAreas